import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { catchError, debounceTime, distinctUntilChanged, first, map, of, switchMap } from "rxjs";
import { TankApprovalsService } from "src/app/services/tank-approvals.service";

export function NfcTagValidator(service: TankApprovalsService, idTank: number | null): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return Promise.resolve(null);
    return control.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(value => service.validateNfcTag(value)),
      map(res => {
        const results = res.data.filter((tank: any) => tank.id !== idTank);
        return results?.length > 0 ? { tagExist: true } : null;
      }),
      catchError(() => of(null)),
      first()
    );
  }
}